import styled from 'styled-components';
import { COLORS_CONFIG } from 'config/index';

// eslint-disable-next-line import/prefer-default-export
export const Button = styled.div`
  color: ${COLORS_CONFIG.SKY_BLUE};
  font-size: 14px;
  cursor: pointer;
`;
